import EVENT_LIST from '../../graphql/event/list.graphql'
import EVENT_CREATE from '../../graphql/event/create.graphql'
import EVENT_UPDATE from '../../graphql/event/update.graphql'
import EVENT_DELETE from '../../graphql/event/delete.graphql'

import {processMutation, processQuery, genericMutations} from '../utils'

export default {
    namespaced: true,
    state: {
        list: [],
        detail: null,
    },

    mutations: {
        ...genericMutations('list', 'detail'),
    },

    actions: {
        async list({commit}) {
            return await processQuery(this, EVENT_LIST, 'event.list', {}, 'event/setList')
        },

        async create({commit}, data) {
            return await processMutation(this, EVENT_CREATE, 'event.create', data)
        },

        async delete({commit}, id) {
            return await processMutation(this, EVENT_DELETE, 'event.delete', {id: id})
        },

        async update({commit}, data) {
            return await processMutation(this, EVENT_UPDATE, 'event.update', data)
        }
    }
}